import { gql } from 'graphql-request';

const STANDALONE_INVOICE_FIELDS = `
  standaloneInvoiceId
  recipientEmail
  currency
  subtotal
  taxRate
  tax
  discountRate
  discountFixedAmount
  discountAmount
  total
  organizationId
  projectId
  status
  nmiInvoiceId
  sentAt
  createdAt
  lineItems {
    description
    quantity
    unitPrice
    lineTotal
  }
`;

export const createAndSendStandaloneInvoiceMutation = gql`
  mutation createAndSendStandaloneInvoice($input: CreateStandaloneInvoiceInput!) {
    createAndSendStandaloneInvoice(input: $input) {
      ${STANDALONE_INVOICE_FIELDS}
    }
  }
`;

export const projectsForStandaloneInvoiceQuery = gql`
  query projectsForStandaloneInvoice($organizationId: ID!) {
    projectsForStandaloneInvoice(organizationId: $organizationId) {
      projectId
      name
    }
  }
`;

const StandaloneInvoiceGraphQL = {
  queries: {
    projectsForStandaloneInvoice: projectsForStandaloneInvoiceQuery,
  },
  mutations: {
    createAndSend: createAndSendStandaloneInvoiceMutation,
  },
};

export default StandaloneInvoiceGraphQL;
